import _ from 'underscore';

(function () {
    "use strict";

    var moduleObj = moduler('webAudienceCenteredBlock', {
        defaults: {
            categories: '.fCats select[data-section=CategorySelector]',
            subcategories: '.fCats select[data-section=SubCategorySelector]',
            states: '.fCats select[data-section=ActionExpandable]',
            activeClass: 'active'
        },

        init: function(module) {
            if (!window.dropdownObject) {
                console.error('No dropdownObject available, exiting.');
                return;
            }

            module.$element.find('select').on('change.analytics', moduleObj.fireAnalytics);
            module.$element.find(module.settings.categories).on('change.cat', module, moduleObj.handleCategory);
            module.$element.find('select').on('change.checkDisabled', module, moduleObj.checkDisabled);
            module.$element.find('select').on('change.checkCompleted', module, moduleObj.checkCompleted);
            moduleObj.checkDisabled(module);
            moduleObj.checkCompleted(module);
        },

        fireAnalytics: mo.event(function(e) {
            if (!!e) {
                let that = e.currentTarget;
                if (!!that && !!dataLayer) {
                    dataLayer.push({
                        'event': `Selection: ${$('h3', $(that).parents('li')).text()}`,
                        'event-category': 'form-finder',
                        'selection': $(':selected', that).text()
                    });
                }
            }
        }),

        handleCategory: mo.event(function (module, e) {
            let that = e.currentTarget;
            let options = window.dropdownObject[that.value];
            let target = module.$element.find(module.settings.subcategories);

            target.empty().append('<option value="" selected="selected">Please Select...</option>');

            $.each(options, function (key, value) {
                target
                    .append($("<option></option>")
                        .attr("value", value.value)
                        .text(value.text));
            });
        }),

        checkDisabled: mo.event(function (module, e) {
            let cat = module.$element.find(module.settings.categories);
            let sub = module.$element.find(module.settings.subcategories);
            let states = module.$element.find(module.settings.states);

            // check if anything is "ready" on ready event...
            if (cat.val().length) { // we have something chosen...
                cat.closest('span.Select').addClass('hasVal');
                sub.closest('li').removeClass('disabled');
            } else {
                cat.closest('span.Select').removeClass('hasVal');
                sub.closest('li').addClass('disabled');
            }
            if (cat.val().length && sub.val().length) { // if both previous selects are not chosen, disable state.
                sub.closest('span.Select').addClass('hasVal');
                states.closest('li').removeClass('disabled');
            } else {
                sub.closest('span.Select').removeClass('hasVal');
            }
            states.closest('span.Select').toggleClass('hasVal', !!states.val().length);
        }),

        checkCompleted: mo.event(function (module, e) {
            let cat = module.$element.find(module.settings.categories).val();
            let sub = module.$element.find(module.settings.subcategories).val();
            let states = module.$element.find(module.settings.states).val();
            let container = module.$element.find('.fOptions');

            if (!!cat.length && !!sub.length && !!states.length) {
                container.addClass('loading');
                $.ajax({
                    url: `/api/FormsDownloadData/?state=${states}&audience=${sub}&partner=${window.partnerGuid}`
                }).done(function (response) {
                    container.children().hide();
                    if (response.isNewYork) { // is New York
                        container.find('.newYork').show();
                    } else if (!response.forms.length) { // no hits
                        container.find('.noHits').show();
                    } else { // we got hits!
                        let data = {
                            cat: module.$element.find(module.settings.categories).find('option:selected').text(),
                            sub: module.$element.find(module.settings.subcategories).find('option:selected').text(),
                            audience: sub,
                            state: states,
                            results: response
                        };

                        let formIds = []; //used by GetForms in order to package all forms as a zip file
                        let formNumbers = []; //used by GTM

                        for (let form in response.forms) {
                            formIds.push(response.forms[form].formId);
                            formNumbers.push(response.forms[form].formNumber);
                        }

                        data['formIds'] = formIds.join(',');
                        data['formNumbers'] = JSON.stringify(formNumbers);

                        let tpl = _.template(module.$element.find('.tplResults').html());
                        container.find('.results').html(tpl({ data: data })).show();

                        moduleObj.setupForm(module);
                    }
                    container.removeClass('loading');
                }).fail(function () { // if error, just show no hits for now...
                    container.children().hide();
                    container.find('.noHits').show();
                    container.removeClass('loading');
                });
            } else {
                container.children().hide();
                container.find('.noneSelected').show();
            }
        }),

        setupForm: function (module) {
            let toggle = module.$element.find('.fOptions .results .email-share');
            let wrapper = module.$element.find('.fOptions .results .shareForm');
            let form = wrapper.find('form');

            form.removeData("validator").removeData("unobtrusiveValidation");
            $.validator.unobtrusive.parse(form);

            toggle.on('click', function (e) {
                e.preventDefault();
                wrapper.toggle();
            });

            form.on('submit', function (e) {
                e.preventDefault();

                if (!form.validate().valid()) return;

                wrapper.addClass('loading');

                $.ajax({
                    type: 'POST',
                    url: form.attr('action'),
                    data: form.serialize()
                }).done(function (response) {
                    wrapper.children().hide();
                    wrapper.find('.emailSent').show();
                    wrapper.removeClass('loading');
                }).fail(function (response) {
                    wrapper.children().hide();
                    wrapper.find('.emailError').show();
                    wrapper.removeClass('loading');
                });
            });
        }
    });
})();

//TODO: Add css for disabled/hasVal, continue with script for doing api call, parsing response, fix email functionality.